import { cloneElement, FC, ReactElement } from 'react';
import {
  logEventAsArray,
  TAnalyticArgs,
} from '@/containers/AnalyticsContainer';

interface AnalyticsWrapperProps {
  children: ReactElement;
  analytics: TAnalyticArgs;
}

const AnalyticsWrapper: FC<AnalyticsWrapperProps> = ({
  children,
  analytics,
}) => {
  const handleClick = (event: MouseEvent) => {
    logEventAsArray(analytics);
    if (children.props.onClick) {
      children.props.onClick(event);
    }
  };
  return cloneElement(children, {
    onClick: handleClick,
  });
};

export { AnalyticsWrapper };
